exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ivu-table-cell{\n        text-align: center;\n}\n.ivu-table-small th{\n        text-align: center;\n}\n.ivu-table th, .ivu-table td{text-align: center !important;}\nth.ivu-table-column-left, td.ivu-table-column-left{text-align: center !important;}\nth.ivu-table-column-right, td.ivu-table-column-right{text-align: center !important;}\n\t/* 自定义红色星号 */\n.custom-asterisk {\n\tcolor: red;\n\tmargin-right: 4px;\n}\n", ""]);

// exports
